import {Testimonial} from '../../model/testimonial/testimonial.model';

export const TESTIMONIALS: Testimonial[] = [

  {
    review: 'Furkan is a talented full-stack software developer and an all-around good human! He made significant impacts for two years at Big Armor! I truly believe that he will make a bigger impact on upcoming projects.',
    reviewer: {
      name: 'Travis Collins',
      title: 'CEO @Big Armor',
      photoUri: 'assets/testimonial/big-armor.webp',
    },
    social: 'big-armor',
    companyLogo: 'assets/third-parties/logo/big-armor.webp',
    companyWordmark: 'assets/third-parties/logo-wide/big-armor.webp'
  },

  {
    review: 'Working with Furkan has been a very satisfying experience. He was communicative and supportive throughout the project, completing my requirements expertly and in a timely manner.',
    reviewer: {
      name: 'Sinan Ata',
      title: 'Founder @Exceptionly',
      photoUri: 'assets/testimonial/exceptionly.webp',
    },
    social: 'exceptionly',
    companyLogo: 'assets/third-parties/logo/exceptionly.webp',
    companyWordmark: 'assets/third-parties/logo-wide/exceptionly.webp'
  },
  {
    review: `Timing is essential for us in Biyo. That\'s why Codigrate has been so helpful for us. It has saved us hours of time when it comes to integrating third-party applications and automation for our company.`,
    reviewer: {
      name: 'Matt Saricicek',
      title: 'Founder @Biyo',
      photoUri: 'assets/testimonial/biyo.webp',
    },
    social: 'biyo',
    companyLogo: 'assets/third-parties/logo/biyo.webp',
    companyWordmark: 'assets/third-parties/logo-wide/biyo.webp'
  },
  {
    review: `Furkan and his team are knowledgeable, and they know what they are doing. That was an excellent way for us to save money and time. I appreciate their efforts.`,
    reviewer: {
      name: 'Ibrahim Bayer',
      title: 'Co-founder @IB Group',
      photoUri: 'assets/testimonial/bayeras.webp',
    },
    social: 'ib-group',
    companyLogo: 'assets/third-parties/logo/ib-group.webp',
    companyWordmark: 'assets/third-parties/logo-wide/ib-group.webp',
  }
];
